import { useCallback } from 'react';

import { useGetClassroomCourseUrl } from 'common.components/hooks/use-get-clasroom-course-url';

export const useGoToClassroom = () => {
    const getClassroomCourseUrl = useGetClassroomCourseUrl();

    return useCallback(
        (courseId: number) => {
            window.location.href = getClassroomCourseUrl({ courseId });
        },
        [getClassroomCourseUrl]
    );
};
